"use client";

import { AuthFormCard } from "./components/auth-form-card";
import { TriangleAlert } from "lucide-react";
import Link from "next/link";

interface AuthErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function AuthErrorPage({ reset }: AuthErrorPageProps) {
  return (
    <AuthFormCard title="Something went wrong">
      <div className="flex flex-col items-center text-center py-6 space-y-5">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-status-error-bg">
          <TriangleAlert className="h-7 w-7 text-status-error-text" />
        </div>
        <p className="text-sm text-text-secondary">
          We encountered an unexpected error. Please try again or return to the
          sign in page.
        </p>
        <div className="flex items-center gap-3">
          <button
            onClick={reset}
            className="inline-flex items-center justify-center rounded-lg border border-separator-primary bg-white px-5 py-2 text-sm font-medium text-text-primary hover:bg-gray-50 transition-colors duration-200"
          >
            Try again
          </button>
          <Link
            href="/signin"
            className="inline-flex items-center justify-center rounded-lg bg-primary px-5 py-2 text-sm font-medium text-white hover:bg-primary/90 transition-colors duration-200"
          >
            Go to Sign In
          </Link>
        </div>
      </div>
    </AuthFormCard>
  );
}
